import React from 'react';

const NumberOfDoorsIcon = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='17'
        height='16'
        viewBox='0 0 17 16'
        fill='none'
        className={className}
    >
        <path
            d='M6.91667 14V5.33333C6.91667 5.15652 6.84643 4.98695 6.7214 4.86193C6.59638 4.7369 6.42681 4.66667 6.25 4.66667H2.91667C2.73986 4.66667 2.57029 4.7369 2.44526 4.86193C2.32024 4.98695 2.25 5.15652 2.25 5.33333V13.3333C2.25 13.5101 2.32024 13.6797 2.44526 13.8047C2.57029 13.9298 2.73986 14 2.91667 14H10.9167C11.0935 14 11.263 13.9298 11.3881 13.8047C11.5131 13.6797 11.5833 13.5101 11.5833 13.3333V10C11.5833 9.82319 11.5131 9.65362 11.3881 9.5286C11.263 9.40357 11.0935 9.33333 10.9167 9.33333H2.25M10.25 2H13.5833C13.9515 2 14.25 2.29848 14.25 2.66667V6C14.25 6.36819 13.9515 6.66667 13.5833 6.66667H10.25C9.88181 6.66667 9.58333 6.36819 9.58333 6V2.66667C9.58333 2.29848 9.88181 2 10.25 2Z'
            stroke='#00225F'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export { NumberOfDoorsIcon };
